var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoFolderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 93,
    viewBox: "0 0 87 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 115714"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    opacity: 0.17,
    d: "M67 0H19C13.4772 0 9 4.47715 9 10V58C9 63.5228 13.4772 68 19 68H67C72.5228 68 77 63.5228 77 58V10C77 4.47715 72.5228 0 67 0Z",
    fill: "#FFDC69"
  }), /*#__PURE__*/React.createElement("g", {
    id: "button3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    filter: "url(#filter0_d_1_4886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "button1",
    d: "M56.0039 34.003C56.0039 26.8233 50.1836 21.003 43.0039 21.003C35.8242 21.003 30.0039 26.8233 30.0039 34.003C30.0039 41.1827 35.8242 47.003 43.0039 47.003C50.1836 47.003 56.0039 41.1827 56.0039 34.003Z",
    fill: "url(#paint0_linear_1_4886)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M41.6309 31.258L45.2869 34L41.6309 36.742V31.258Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-right_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M40.7168 29.887L46.2008 34L40.7168 38.114V29.887Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_4886",
    x: 0.00390625,
    y: 6.00299,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0784314 0 0 0 0 0.4 0 0 0 0 0.8 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4886"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4886",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4886",
    x1: 56.0039,
    y1: 21.003,
    x2: 30.0039,
    y2: 47.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4584E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CC19C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoFolderIcon);
export default __webpack_public_path__ + "static/media/video-folder-icon.1d1eddbfc6f1b251291121eab41db235.svg";
export { ForwardRef as ReactComponent };